export const it = {
  "BACK_BUTTON": "Ritorno",
  "NEXT_BUTTON": "Il prossimo",
  "FINISH_BUTTON": "Finire",
  "CHOICES_TITLE": "Scelte",
  "SELECT_INPUT": "Selezionare",
  "MULTICHOICE_PEER_PLACEHOLDER": "Seleziona persona/e",
  "MULTICHOICE_PEER_REQUIRED_ERROR": "Seleziona almeno una persona.",
  "MULTICHOICE_OTHER_LABEL": "Altro (specificare)",
  "MULTICHOICE_OTHER_PLACEHOLDER": "Specificare",
  "MULTICHOICE_OTHER_TEXT_REQUIRED": "Specificare la risposta per \"Altro\".",
  "MULTICHOICE_OTHER_TEXT_TOO_LONG": "La risposta deve contenere al massimo 1000 caratteri.",
  "MULTICHOICE_CLEAR_SELECTION": "Cancella selezione",
  "LIKERT_HINT": "Seleziona una persona e assegna un punteggio.",
  "LIKERT_SCORE_LABEL": "Punteggio",
  "LIKERT_INCOMPLETE_ERROR": "Seleziona persona e punteggio per ogni riga.",
  "LIKERT_INVALID_ERROR": "Uno o più punteggi sono fuori dall'intervallo consentito.",
  "EMPTY_ERROR": "Non può essere vuoto!",
    "SUBMIT_ERROR": "Impossibile inviare le risposte. Controlla le risposte.",
  "SENDING_DATA": "Dati inviati!",
  "LOADING": "Caricamento...",
  "MAX_SELECT_ERROR": "Il limite massimo è",
  "FORM_ALREADY_ANSWERED": "Hai già compilato il form! Grazie",
  "MAX_SELECT_CUSTOM_MESSAGE": "Hai raggiunto il valore massimo dell'opzione",
  "SKILL_PLACEHOLDER": "Livello di abilità",
  "QR_SELECT_TITLE": "Seleziona il tuo nome",
  "QR_SELECT_PLACEHOLDER": "Cerca il tuo nome...",
  "QR_NO_PARTICIPANTS": "Nessun partecipante disponibile. Tutti i partecipanti hanno già risposto.",
  "QR_SURVEY_NOT_FOUND": "Sondaggio non trovato",
  "QR_LOAD_ERROR": "Impossibile caricare i partecipanti. Riprova.",
  "QR_PARTICIPANT_ALREADY_ANSWERED": "Questo partecipante ha già completato il sondaggio. Torna indietro e seleziona di nuovo il tuo nome.",
  "QR_BACK_TO_SELECTION": "Torna alla selezione del nome",
  "companyValues": {
    "PASSION": "Passione per tutto ciò che facciamo",
    "INNOVATING": "Innovare sempre",
    "CONFIDENCE": "Con fiducia e responsabilità",
    "WINNING": "Vincere in squadra",
    "DIFFERENCE": "Impegnati a fare la differenza"
  },
  "THANK_YOU": "Grazie!"
}
